export default "__VITE_ASSET__b5aba9d6__"